import React from "react";

const Header = () => (
  <header className="bg-white shadow p-4 mb-4">
    <div className="container mx-auto flex items-center justify-between">
      <h1 className="text-xl font-bold" style={{ color: "#064c39" }}>Create a Co-op</h1>
    </div>
  </header>
);

export default Header;
